(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["g4p-bundle"] && !Shopify.designMode) return;
  try {
    class BundleBuilder extends HTMLElement {
    connectedCallback(){
      this.tiers = {
        1: 0,
        [this.dataset.tier1Qty]: parseInt(this.dataset.tier1Pct,10),
        [this.dataset.tier2Qty]: parseInt(this.dataset.tier2Pct,10)
      };
      this.target = 0;      // chosen tier size
      this.pct = 0;         // chosen tier discount
      this.qty = {};        // { variantId: {name, price, count} } — mirror of cart box lines

      // Set of every box variant id this builder knows about. Used to tell
      // which cart line items are "our" boxes when we read the cart on load.
      this.boxIds = new Set(
        Array.from(this.querySelectorAll('[data-row]')).map(r => String(r.dataset.variantId))
      );

      // localStorage key for the chosen tier (cart can't remember the tier).
      this.tierKey = 'g4p_bundle_tier';

      // Debounce + queue state for cart writes.
      this._syncTimer = null;
      this._syncing = false;
      this._pendingSync = false;

      this.$ = (s)=>this.querySelector(s);
      this.rowsEl = this.$('[data-rows]');
      this.addBtn = this.$('[data-add]');
      this.buttonLabel = this.addBtn.textContent.trim();

      // tier selection
      this.querySelectorAll('[data-tier]').forEach(btn=>{
        btn.addEventListener('click', ()=>{
          this.querySelectorAll('[data-tier]').forEach(b=>b.classList.remove('is-sel'));
          btn.classList.add('is-sel');
          this.target = parseInt(btn.dataset.tier,10);
          this.pct = parseInt(btn.dataset.pct,10);
          this.classList.add('is-ready');
          this.saveTier();
          // if reducing tier below current count, trim (and push the trim to cart)
          this.trimToTarget();
          this.render();
          this.queueSync();
        });
      });

      // steppers
      this.rowsEl.addEventListener('click', (e)=>{
        const row = e.target.closest('[data-row]');
        if(!row || row.hasAttribute('data-oos')) return;
        const id = row.dataset.variantId;
        if(e.target.closest('[data-inc]')) this.inc(id, row);
        if(e.target.closest('[data-dec]')) this.dec(id);
      });

      this.addBtn.addEventListener('click', ()=>this.goToCart());

      // View more toggle
      this.setupViewMore();

      // Read the live cart first, then restore tier, then wire the current box.
      this.initFromCart();
    }

    // ---------- persistence: tier ----------
    saveTier(){
      try { localStorage.setItem(this.tierKey, JSON.stringify({ t:this.target, pct:this.pct })); } catch(e){}
    }
    loadTier(){
      try { return JSON.parse(localStorage.getItem(this.tierKey)); } catch(e){ return null; }
    }
    selectTierButton(t){
      const btn = this.querySelector('[data-tier="'+t+'"]');
      if(!btn) return false;
      this.querySelectorAll('[data-tier]').forEach(b=>b.classList.remove('is-sel'));
      btn.classList.add('is-sel');
      this.target = parseInt(btn.dataset.tier,10);
      this.pct = parseInt(btn.dataset.pct,10);
      this.classList.add('is-ready');
      return true;
    }

    // ---------- init: read the real cart ----------
    async initFromCart(){
      let cart = null;
      try {
        const res = await fetch('/cart.js', { headers:{ 'Accept':'application/json' } });
        if(res.ok) cart = await res.json();
      } catch(e){ /* offline / blocked — fall back to empty */ }

      // Rebuild this.qty from any box line items already in the cart.
      if(cart && Array.isArray(cart.items)){
        cart.items.forEach(it=>{
          const id = String(it.id);
          if(!this.boxIds.has(id)) return;
          const row = this.querySelector('[data-row][data-variant-id="'+id+'"]');
          if(!row) return;
          this.qty[id] = {
            name: row.dataset.name,
            price: parseInt(row.dataset.price,10),
            count: it.quantity
          };
        });
      }

      const boxesInCart = this.total();

      // Restore the saved tier if we have one; otherwise infer a sensible one.
      const saved = this.loadTier();
      if(saved && this.selectTierButton(saved.t)){
        // tier restored from localStorage
      } else if(boxesInCart > 0){
        // No saved tier but boxes exist — pick the smallest tier that fits them.
        const tierSizes = [1, parseInt(this.dataset.tier1Qty,10), parseInt(this.dataset.tier2Qty,10)]
          .sort((a,b)=>a-b);
        let chosen = tierSizes[tierSizes.length-1];
        for(const t of tierSizes){ if(boxesInCart <= t){ chosen = t; break; } }
        this.selectTierButton(chosen);
      }

      // If cart already holds boxes, don't auto-add the current one — respect
      // what they built. Only seed the current box for a fresh, empty build.
      if(boxesInCart === 0){
        this.autoSelectCurrent();
      } else {
        // still highlight the current box row for orientation, and move it up
        this.hoistCurrentRow(false);
      }

      // If restored count exceeds the tier cap (e.g. tier changed elsewhere),
      // trim down and push the correction to the cart.
      if(this.target > 0 && this.total() > this.target){
        this.trimToTarget();
        this.queueSync();
      }

      this.render();
    }

    hoistCurrentRow(seed){
      const currentId = this.dataset.currentVariant;
      if(!currentId) return;
      const row = this.querySelector('[data-row][data-variant-id="'+currentId+'"]');
      if(!row) return;
      this.rowsEl.insertBefore(row, this.rowsEl.firstElementChild);
      row.classList.add('is-current');
      if(seed && !row.hasAttribute('data-oos') && !this.qty[currentId]){
        this.qty[currentId] = { name: row.dataset.name, price: parseInt(row.dataset.price,10), count: 1 };
      }
    }

    setupViewMore(){
      const rows = this.querySelectorAll('[data-row]');
      const moreBtn = this.$('[data-more]');
      if(!moreBtn) return;
      const LIMIT = 5;
      if(rows.length <= LIMIT){ moreBtn.hidden = true; return; }
      moreBtn.hidden = false;

      const remaining = rows.length - LIMIT;
      const moreLabel = 'View ' + remaining + ' more boxes';
      const lessLabel = 'Show less';
      moreBtn.textContent = moreLabel;
      moreBtn.addEventListener('click', ()=>{
        const collapsed = this.rowsEl.classList.toggle('is-collapsed');
        moreBtn.textContent = collapsed ? moreLabel : lessLabel;
        if(collapsed){
          this.rowsEl.scrollIntoView({behavior:'smooth', block:'nearest'});
        }
      });
    }

    autoSelectCurrent(){
      const currentId = this.dataset.currentVariant;
      if(!currentId) return;
      const row = this.querySelector('[data-row][data-variant-id="'+currentId+'"]');
      if(!row) return;

      // move the current box to the TOP so it's always within the visible 6
      this.rowsEl.insertBefore(row, this.rowsEl.firstElementChild);

      // default to the 1-box tier so a single box is immediately valid,
      // unless a tier was already restored from localStorage.
      if(this.target === 0){
        const oneTier = this.querySelector('[data-tier="1"]');
        if(oneTier){
          this.querySelectorAll('[data-tier]').forEach(b=>b.classList.remove('is-sel'));
          oneTier.classList.add('is-sel');
          this.target = 1;
          this.pct = 0;
          this.classList.add('is-ready');
          this.saveTier();
        }
      }

      // put 1 of this box in (local only; pushed to cart by the initial sync)
      if(!row.hasAttribute('data-oos')){
        this.qty[currentId] = { name: row.dataset.name, price: parseInt(row.dataset.price,10), count: 1 };
        this.queueSync();
      }

      row.classList.add('is-current');
    }

    total(){ return Object.values(this.qty).reduce((s,i)=>s+i.count,0); }

    inc(id, row){
      if(this.target === 0) return;
      if(this.total() >= this.target) return; // full
      if(!this.qty[id]) this.qty[id] = { name: row.dataset.name, price: parseInt(row.dataset.price,10), count: 0 };
      this.qty[id].count++;
      this.render();
      this.queueSync();
    }
    dec(id){
      if(!this.qty[id]) return;
      this.qty[id].count--;
      if(this.qty[id].count <= 0) delete this.qty[id];
      this.render();
      this.queueSync();
    }
    trimToTarget(){
      let over = this.total() - this.target;
      if(over <= 0) return;
      for(const id of Object.keys(this.qty)){
        while(over > 0 && this.qty[id]){
          this.qty[id].count--; over--;
          if(this.qty[id].count <= 0) delete this.qty[id];
        }
        if(over <= 0) break;
      }
    }

    money(c){ return '$' + (c/100).toFixed(2); }

    // ---------- cart sync ----------
    // Debounce rapid clicks, then push the full desired box state to the cart.
    queueSync(){
      this.classList.add('g4pb__syncing');
      clearTimeout(this._syncTimer);
      this._syncTimer = setTimeout(()=>this.syncToCart(), 350);
    }

    async syncToCart(){
      // If a sync is already in flight, mark that another is needed and bail;
      // the in-flight one will re-trigger when it finishes.
      if(this._syncing){ this._pendingSync = true; return; }
      this._syncing = true;

      try {
        // Build one desired-state map for every box id we own:
        //   every known box id -> 0, then overwrite with the chosen counts.
        // /cart/update.js takes this map and CREATES, updates, or REMOVES the
        // matching lines in a single request. Unlike change.js it works even
        // when the line doesn't exist in the cart yet (the empty-cart case),
        // which is why boxes weren't landing before.
        const updates = {};
        this.boxIds.forEach(id => { updates[id] = 0; });
        Object.keys(this.qty).forEach(id => { updates[id] = this.qty[id].count; });

        const res = await fetch('/cart/update.js', {
          method:'POST',
          headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
          body: JSON.stringify({ updates: updates })
        });
        if(!res.ok) throw new Error('cart update ' + res.status);

        // Reconcile UI against the authoritative cart the server returned, so
        // if anything got clamped or rejected the steppers show the truth.
        // Skip if the user has queued another change in the meantime — the
        // follow-up sync will reconcile against the newer intent instead, and
        // reconciling here would flicker their fresh click back to old state.
        const cart = await res.json();
        if(!this._pendingSync && cart && Array.isArray(cart.items)){
          const server = {};
          cart.items.forEach(it=>{
            const id = String(it.id);
            if(this.boxIds.has(id)) server[id] = it.quantity;
          });
          // rebuild this.qty from the server's box lines
          const rebuilt = {};
          Object.keys(server).forEach(id=>{
            const row = this.querySelector('[data-row][data-variant-id="'+id+'"]');
            if(!row) return;
            rebuilt[id] = { name: row.dataset.name, price: parseInt(row.dataset.price,10), count: server[id] };
          });
          this.qty = rebuilt;
          this.render();
        }
      } catch(err){
        // Non-fatal: the UI still reflects intent; next change re-syncs.
        // eslint-disable-next-line no-console
        console.error('G4P bundle cart sync failed:', err);
      } finally {
        this._syncing = false;
        this.classList.remove('g4pb__syncing');
        if(this._pendingSync){
          this._pendingSync = false;
          this.queueSync();
        }
      }
    }

    render(){
      const total = this.total();
      const full = this.target > 0 && total >= this.target;

      const countEl = this.$('[data-count]');
      countEl.textContent = total + ' / ' + (this.target || 0);
      countEl.classList.toggle('is-full', full && this.target>0);

      this.querySelectorAll('[data-row]').forEach(row=>{
        const id = row.dataset.variantId;
        const c = this.qty[id] ? this.qty[id].count : 0;
        row.querySelector('[data-qty]').textContent = c;
        const inc = row.querySelector('[data-inc]');
        const dec = row.querySelector('[data-dec]');
        dec.disabled = c === 0;
        inc.disabled = this.target === 0 || full;
      });

      const subtotal = Object.values(this.qty).reduce((s,i)=>s+i.price*i.count,0);
      const savings = this.pct ? Math.round(subtotal*this.pct/100) : 0;
      const grand = subtotal - savings;
      this.$('[data-subtotal]').textContent = this.money(subtotal);
      this.$('[data-total]').textContent = this.money(grand);
      const sl = this.$('[data-saveline]');
      if(this.pct && savings>0){
        sl.hidden = false;
        this.$('[data-savelabel]').textContent = 'Discount (' + this.pct + '% off)';
        this.$('[data-savings]').textContent = '-' + this.money(savings);
      } else { sl.hidden = true; }

      const fine = this.$('[data-fine]');
      if(this.target === 0){
        this.addBtn.disabled = true;
        this.addBtn.textContent = 'Choose a size to start';
        fine.textContent = 'Pick 1, ' + this.dataset.tier1Qty + ', or ' + this.dataset.tier2Qty + ' boxes above.';
      } else if(!full){
        this.addBtn.disabled = true;
        const left = this.target - total;
        this.addBtn.textContent = 'Add ' + left + ' more box' + (left>1?'es':'');
        fine.textContent = 'Your boxes are saved to your cart as you go.';
      } else {
        this.addBtn.disabled = false;
        this.addBtn.textContent = 'Continue \u00b7 ' + this.money(grand);
        fine.textContent = 'Saved to your cart. Discount applied automatically at checkout.';
      }
    }

    // Everything is already in the cart; just move them forward.
    async goToCart(){
      const total = this.total();
      if(this.target === 0 || total < this.target) return;
      this.addBtn.disabled = true;
      this.addBtn.textContent = 'Saving\u2026';

      // Make sure any pending debounce is flushed before we navigate.
      clearTimeout(this._syncTimer);
      await this.syncToCart();

      const customizeUrl = this.dataset.customizeUrl;
      window.location.href = customizeUrl && customizeUrl.length ? customizeUrl : '/cart';
    }
  }
  if(!customElements.get('bundle-builder')) customElements.define('bundle-builder', BundleBuilder);
  } catch(e) { console.error(e); }
})();

})();
